import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import AdminLayout from './components/AdminLayout';

// Lazy loading pages for optimal initial load bundle size
const Login = lazy(() => import('./pages/Login'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const Users = lazy(() => import('./pages/Users'));
const Agenda = lazy(() => import('./pages/Agenda'));
const Speakers = lazy(() => import('./pages/Speakers'));
const Questions = lazy(() => import('./pages/Questions'));
const Streaming = lazy(() => import('./pages/Streaming'));
const Configs = lazy(() => import('./pages/Configs'));
const AdminPollResults = lazy(() => import('./pages/AdminPollResults'));
const Surveys = lazy(() => import('./pages/Surveys'));
const SurveyStats = lazy(() => import('./pages/SurveyStats'));
const Trivia = lazy(() => import('./pages/Trivia'));
const PageBuilder = lazy(() => import('./pages/PageBuilder'));
const Salas = lazy(() => import('./pages/Salas'));
const Reports = lazy(() => import('./pages/Reports'));
const Bingo = lazy(() => import('./pages/Bingo'));

const PageLoader = () => (
    <div className="h-screen w-full flex flex-col items-center justify-center bg-slate-900 text-white">
        <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-6"></div>
        <span className="font-black text-xs uppercase tracking-[0.3em] opacity-40">Cargando...</span>
    </div>
);

// Protected Route Component
const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    if (loading) return <PageLoader />;
    if (!user) return <Navigate to="/login" />;
    return <AdminLayout>{children}</AdminLayout>;
};

function App() {
    return (
        <AuthProvider>
            <Router>
                <Suspense fallback={<PageLoader />}>
                    <Routes>
                        <Route path="/login" element={<Login />} />

                        {/* Protected Routes */}
                        <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                        <Route path="/users" element={<ProtectedRoute><Users /></ProtectedRoute>} />
                        <Route path="/salas" element={<ProtectedRoute><Salas /></ProtectedRoute>} />
                        <Route path="/agenda" element={<ProtectedRoute><Agenda /></ProtectedRoute>} />
                        <Route path="/speakers" element={<ProtectedRoute><Speakers /></ProtectedRoute>} />
                        <Route path="/questions" element={<ProtectedRoute><Questions /></ProtectedRoute>} />
                        <Route path="/streaming" element={<ProtectedRoute><Streaming /></ProtectedRoute>} />
                        <Route path="/configs" element={<ProtectedRoute><Configs /></ProtectedRoute>} />
                        <Route path="/surveys" element={<ProtectedRoute><Surveys /></ProtectedRoute>} />
                        <Route path="/survey-stats" element={<ProtectedRoute><SurveyStats /></ProtectedRoute>} />
                        <Route path="/trivia" element={<ProtectedRoute><Trivia /></ProtectedRoute>} />
                        <Route path="/bingo" element={<ProtectedRoute><Bingo /></ProtectedRoute>} />
                        <Route path="/resultados" element={<ProtectedRoute><AdminPollResults /></ProtectedRoute>} />
                        <Route path="/reportes" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
                        <Route path="/pages-builder" element={<ProtectedRoute><PageBuilder /></ProtectedRoute>} />

                        <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                </Suspense>
            </Router>
        </AuthProvider>
    );
}

export default App;
